import { render } from "./Footer.vue?vue&type=template&id=bb1bc450&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=bb1bc450&lang=scss&scoped=true"

import exportComponent from "D:\\work\\jp\\cbredata\\creis_develop\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb1bc450"]])

export default __exports__